import React, { useEffect,  useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { getFieldFormFile } from 'utils/FieldTestsUtils';
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));


const ArtifactListItem = ({ Artifact }) => {
  return (
    <ListItem button component="a" target="_blank" href={Artifact.url}>
      <ListItemAvatar>
        <Avatar>
          <PictureAsPdfIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary="PDF" secondary={`${Artifact.date}`} />
    </ListItem>
  )
}

const ArtifactsDisplay = ({ FieldTestId }) => {
  const classes = useStyles();
  const [ artifacts, setArtifacts ] = useState({ready: false, data: [] });
  
  useEffect(() => {
    const asyncEffect = async () => {
      const req = await getFieldFormFile(FieldTestId);
      console.log(req)
      setArtifacts({ready: true, data: req });
    };
    asyncEffect();
  }, [FieldTestId]);

  return (
    <Grid container justify='center'>
      <Grid item xs={12} style={{ padding: 24 }}>
        <Card raised>
          <CardContent>
            <List className={classes.root}>
              {artifacts.data.map((r, i) => <ArtifactListItem Artifact={r} key={r.date} />)}
              {!artifacts.ready && <CenteredCircularProgress />}
              {artifacts.ready && artifacts.data.length === 0 && <Typography variant="h6">No Artifacts Found.</Typography>}
            </List>
          </CardContent>
        </Card>
      </Grid></Grid>
  )
}

export default ArtifactsDisplay;